import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import Button from 'packages/ui/Button';
import { Link } from 'react-router-dom';

const EditCircle = React.lazy(() => import('./EditCircle'));

function EditCirclePage(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>ویرایش دایره</PageTitle>
        <Button as={Link} type="anchor" to="/circles">
          بازگشت به لیست
        </Button>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <EditCircle {...props} />
      </Suspense>
    </Page>
  );
}

export default EditCirclePage;
